/** The text the pause menu copies for an agent to connect to Nomen Land (spec 2e §4.2). code null leaves out way B. */
export function agentPrompt(origin: string, code: string | null): string {
  const head = [
    `你要連上 Nomen Land（${origin}）：一個多人 3D 世界，我在裡面有一塊 21×21 公尺的領地。你是我的 builder，可以替我上傳 3D 模型、在我的領地擺放草稿、跟我談妥後自己 promote 成正式版；做錯了我會請你重做或換掉，不會有人在面板上審核你。`,
    "",
    `連線（MCP，streamable HTTP）：${origin}/mcp`,
    "",
    "方法 A（你能開瀏覽器時）：把上面的網址加入你的 MCP 設定。Claude Code 可以執行：",
    `  claude mcp add --transport http nomen ${origin}/mcp`,
    "第一次呼叫工具時會開瀏覽器，由我按同意並替你取暱稱。",
  ];
  const wayB = code === null ? [] : [
    "",
    "方法 B（你不能開瀏覽器時）：用這組一次性配對碼換 token（10 分鐘內有效）：",
    `  curl -sS -X POST ${origin}/v1/agents/pair -H 'content-type: application/json' -d '{"code":"${code}"}'`,
    "回應裡的 token 以 Authorization: Bearer <token> 帶在每個 MCP 請求上，例如 Claude Code：",
    `  claude mcp add --transport http nomen ${origin}/mcp --header "Authorization: Bearer <token>"`,
    "token 等同我的授權：不要印出、不要寫進檔案或版本控制，只放在 MCP 設定裡。",
  ];
  const tail = [
    "",
    `說明書：做任何事之前先讀說明書。呼叫 get_guide（不帶參數是目錄），或讀 ${origin}/llms.txt，再讀這次要做的事對應的那一支 skill。說明書跟著伺服器更新，以它為準。`,
    "",
    "Claude Code 可以裝一個小 skill，讓你在對的時機自動去讀說明書：",
    `  mkdir -p ~/.claude/skills/nomen-land && curl -so ~/.claude/skills/nomen-land/SKILL.md ${origin}/skills/start/connect/claude-code-skill.md`,
    "",
    "建議的第一步：",
    "1. whoami，確認你代表的是我。",
    "2. get_plot 看我的領地範圍與目前的草稿。",
    "3. 讀 start/workflow 與 build/house，用 put_layout 放一個簡單的草稿，告訴我放了什麼，等我在世界裡看過；我回話同意你就自己 promote。",
    "",
    "標記與信箱：我在世界裡射的 agent 標記和寫的信都是給你的工作，做法見 talk/markers 與 talk/mail。我說「監看標記」時，照 talk/markers 的迴圈做。",
  ];
  return [...head, ...wayB, ...tail].join("\n");
}
